// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__hyIvL","formContent":"style_formContent__Nsoqn","wrapper":"style_wrapper__PUEAI","authFooter":"style_authFooter__cCHBg","mobileAds":"style_mobileAds__AKEHp"};